// 新消息提示音：浏览器自带语音合成朗读「您有新消息」，不依赖外部音频文件
// （2026-10-06 Gavin 要求换成人声播报，原来是现场生成的"叮"声；音量拉到最大 1.0）。
// 朗读跟原来的"叮"声一样要求先有一次用户手势才能发声，unlockAudio() 挂在首次点击上提前解锁/预热。
let ctx = null

export function unlockAudio() {
  if (!ctx) {
    try { ctx = new (window.AudioContext || window.webkitAudioContext)() } catch { /* 不支持就算了，退回纯语音播报 */ }
  }
  if (ctx?.state === 'suspended') ctx.resume().catch(() => {})
  // Chrome 第一次朗读前要先取一次语音列表，否则第一句常被吞掉前半句
  window.speechSynthesis?.getVoices()
}

// 浏览器完全不支持语音合成时的退路：现场生成一声"叮"，总比完全没提示好
function beep() {
  if (!ctx) return
  try {
    const o = ctx.createOscillator()
    const g = ctx.createGain()
    o.type = 'sine'
    o.frequency.value = 880
    g.gain.setValueAtTime(0.0001, ctx.currentTime)
    g.gain.exponentialRampToValueAtTime(0.6, ctx.currentTime + 0.01)
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.25)
    o.connect(g); g.connect(ctx.destination)
    o.start()
    o.stop(ctx.currentTime + 0.25)
  } catch { /* 静默：提示音失败不该影响使用 */ }
}

export function playAlert() {
  if (!window.speechSynthesis) { beep(); return }
  try {
    const u = new SpeechSynthesisUtterance('您有新消息')
    u.lang = 'zh-CN'
    u.volume = 1
    u.rate = 1.05
    u.onerror = beep
    window.speechSynthesis.speak(u)
  } catch { beep() }
}
